/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Common_Days_AgoInputs */

const en_common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}d ago`)
};

const de_common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vor ${i?.count} T.`)
};

const fr_common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il y a ${i?.count} j`)
};

const es_common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hace ${i?.count} d`)
};

const it_common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}d fa`)
};

const nl_common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}d geleden`)
};

const pl_common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}d temu`)
};

const fi_common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}d sitten`)
};

const da_common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}d siden`)
};

const sv_common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}d sedan`)
};

/**
* | output |
* | --- |
* | "{count}d ago" |
*
* @param {Common_Days_AgoInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_days_ago = /** @type {((inputs: Common_Days_AgoInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Days_AgoInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_days_ago(inputs)
	if (locale === "fr") return fr_common_days_ago(inputs)
	if (locale === "es") return es_common_days_ago(inputs)
	if (locale === "it") return it_common_days_ago(inputs)
	if (locale === "nl") return nl_common_days_ago(inputs)
	if (locale === "pl") return pl_common_days_ago(inputs)
	if (locale === "fi") return fi_common_days_ago(inputs)
	if (locale === "da") return da_common_days_ago(inputs)
	if (locale === "sv") return sv_common_days_ago(inputs)
	return en_common_days_ago(inputs)
});